import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  inject,
  signal,
} from '@angular/core';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LanguageService } from '@core/i18n/language.service';
import { getFormattedTime, TimeData } from '@shared/utils/date-utils';

@Component({
    selector: 'app-clock',
    imports: [],
    templateUrl: './clock.component.html',
    styleUrl: './clock.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClockComponent implements OnInit, OnDestroy {
  private readonly languageService = inject(LanguageService);
  private readonly destroy$ = new Subject<void>();
  private monthsShort: Record<string, string> = {};

  readonly time = signal<TimeData>(this.getInitialTime());

  ngOnInit(): void {
    this.loadTranslations();

    this.languageService.forceChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.loadTranslations();
      });

    interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.time.set(getFormattedTime(this.monthsShort));
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

    private loadTranslations(): void {
      this.languageService.getSharedDictionary('months_short').pipe(
        takeUntil(this.destroy$)
      ).subscribe((translations: any) => {
        this.monthsShort = translations || {};
        this.time.set(getFormattedTime(this.monthsShort));
      });
    }

  private getInitialTime(): TimeData {
    const now = new Date();
    const day = now.getUTCDate().toString().padStart(2, '0');
    const monthIndex = now.getUTCMonth();
    const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const year = now.getUTCFullYear();
    const hours = now.getUTCHours().toString().padStart(2, '0');
    const minutes = now.getUTCMinutes().toString().padStart(2, '0');

    return {
      dateFormatted: `${day} ${monthNames[monthIndex]} ${year}`,
      timeFormatted: `${hours}:${minutes}`,
    };
  }
}
